import BackButton, { CardPreview, Layout, OnboardingAuth } from '../../components';
import { OnboardingFormValues } from '../../components/OnboardingForm';

interface Props {
  hideAuth: () => void;
  formValues?: OnboardingFormValues;
}

const OnboardingAuthContainer = ({ hideAuth, formValues }: Props) => {
  return (
    <Layout rightPanel={formValues && <CardPreview formValues={formValues} />}>
      <OnboardingAuth hideAuth={hideAuth} />
      <BackButton onClick={hideAuth} />
    </Layout>
  );
};

OnboardingAuthContainer.displayName = 'OnboardingAuthContainer';

export default OnboardingAuthContainer;
